export default __webpack_public_path__ + "static/media/icon-sortable.6a125d44.svg";